import { createFileRoute } from '@tanstack/react-router';
import ComingSoonCover from '@/components/ComingSoonCover';
export const Route = createFileRoute('/_staff/settings/contracting-corporation-profile/_layout/group-companies/')({
  component: GroupCompaniesComingSoon
});
function GroupCompaniesComingSoon() {
  return <ComingSoonCover disableBlurBackdrop={true} />;
}